var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13,
  _t14;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import * as dayjs from 'dayjs';
import translations from './translations';
import css from './style.pcss';
import IconArrow from "./images/ic_arrow.svg";
var RTLGuidageParking = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLGuidageParking, _LitElement);
  function RTLGuidageParking() {
    var _this;
    _classCallCheck(this, RTLGuidageParking);
    _this = _callSuper(this, RTLGuidageParking);
    _this.language = 'lu';
    _this.showall = false;
    if (window.rtlsites) {
      _this.language = window.rtlsites.config.language;
    }
    _this.apiUrl = "https://api-gate.rtl.lu/traffic/parking-places";
    return _this;
  }
  _createClass(RTLGuidageParking, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLGuidageParking.prototype), "connectedCallback", this).call(this);
      this._fetchData();
    }
  }, {
    key: "_getTranslation",
    value: function _getTranslation(key) {
      if (!translations[key]) {
        console.warn(key + ' is not defined in translations.js!');
      } else return translations[key][this.language];
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      fetch(this.apiUrl).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this2.data = resp;
        if (Object.keys(_this2.data).length > 0) {
          _this2.city = Object.keys(_this2.data)[0];
          _this2.sector = Object.keys(_this2.data[_this2.city])[0];
        }
      });
    }
  }, {
    key: "_changeSector",
    value: function _changeSector(e) {
      var splitted = e.target.value.split(";");
      this.sector = splitted[0];
      this.city = splitted[1];
      return;
    }
  }, {
    key: "_renderParking",
    value: function _renderParking(parking) {
      var data = '';
      var openText = '';
      var tendance = '';
      if (parking.ouvert == 0) openText = this._getTranslation('closed');
      if (parking.ouvert == 1) openText = this._getTranslation('open');
      if (parking.ouvert == -1) openText = this._getTranslation('nodata');
      if (parking.tendance == 0) tendance = html(_t || (_t = _`<svg class="tendance-arrow" id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67.64 44.48"><defs></defs><title>arrow</title><path class="color-arrow" d="M41.31,34.57,47.82,28l-42.11.08a5.81,5.81,0,0,1,0-11.62l42.12-.07L41.27,9.92a5.81,5.81,0,1,1,8.2-8.23L65.93,18.1a5.81,5.81,0,0,1,0,8.22h0L49.54,42.78a5.81,5.81,0,0,1-8.23-8.21Z"/></svg>`));
      if (parking.tendance == 1) tendance = html(_t2 || (_t2 = _`<svg class="tendance-arrow tendance-arrow--down" id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51.31 51.31"><defs></defs><title>arrow_down</title><path class="color-arrow-down" d="M22.26,39.69h9.22L1.7,9.92A5.81,5.81,0,0,1,9.92,1.7L39.69,31.48V22.27a5.81,5.81,0,0,1,11.62,0V45.5a5.81,5.81,0,0,1-5.81,5.81H22.26a5.81,5.81,0,0,1,0-11.62Z" transform="translate(0 0)"/></svg>`));
      if (parking.tendance == -1) tendance = html(_t3 || (_t3 = _`<svg class="tendance-arrow tendance-arrow--up" id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51.23 51.23"><defs></defs><title>arrow_up</title><path class="color-arrow-up" d="M39.69,29.05V19.83L9.92,49.61A5.81,5.81,0,0,1,1.7,41.4L31.48,11.62H22.26A5.81,5.81,0,0,1,22.26,0H45.5a5.81,5.81,0,0,1,5.81,5.81h0V29.05a5.81,5.81,0,0,1-11.62,0Z" transform="translate(-0.08 0)"/></svg>`));
      if (parking.total > 0) {
        data = html(_t4 || (_t4 = _`
                <td class="guidage-parking__td">${0}</td>
                <td class="guidage-parking__td guidage-parking__td--percentage">${0}%</td>
                <td class="guidage-parking__td guidage-parking__td--occupation">
                    <div class="green-line">
                        <div class="red-line" style="width: ${0}%;"></div>
                    </div>
                </td>
                <td class="guidage-parking__td ">${0}</td>
                <td class="guidage-parking__td">${0}</td>
            `), parking.total, parking.percentage_full, parking.percentage_full, parking.actuel, tendance);
      } else {
        data = html(_t5 || (_t5 = _`<td class="guidage-parking__td guidage-parking__td--text" colspan="5">${0}</td>`), openText);
      }
      return html(_t6 || (_t6 = _`
            <tr class="guidage-parking__tr guidage-parking__tr--grey tr-height">
                <td class="guidage-parking__name-parking">${0}</td>
                ${0}
            </tr>
        `), parking.title, data);
    }
  }, {
    key: "_renderAll",
    value: function _renderAll() {
      var _this3 = this;
      var data = this.data;
      return html(_t7 || (_t7 = _`
            ${0}
        `), Object.keys(data).map(function (city) {
        return html(_t8 || (_t8 = _`
                    <h1 class="guidage-parking__city">${0}</h1>
                    ${0}
                `), city, Object.keys(data[city]).map(function (key) {
          return _this3._renderSector(key, city);
        }));
      }));
    }
  }, {
    key: "_renderSector",
    value: function _renderSector(sector, city) {
      var _this4 = this;
      var key = this.sector;
      var c = this.city;
      if (sector !== undefined) key = sector;
      if (city !== undefined) c = city;
      return html(_t9 || (_t9 = _`
            ${0}
            <table class="guidage-parking__table default-table">
                <tr class="guidage-parking__tr tr-grey tr-height">
                    <th class="guidage-parking__th" align="left">${0}</th>
                    <th class="guidage-parking__th">${0}</th>
                    <th class="guidage-parking__th guidage-parking__th--display" colspan="2">${0}</th>
                    <th class="guidage-parking__th">${0}</th>
                    <th class="guidage-parking__th">${0}</th>
                </tr>
                ${0}
            </table>
        `), this.showall ? html(_t10 || (_t10 = _`<h1 class="guidage-parking__title">${0} ${0}</h1>`), this._getTranslation('sector'), key) : ``, this._getTranslation('parking'), this._getTranslation('capacity'), this._getTranslation('occupation'), this._getTranslation('libre'), this._getTranslation('tendance'), this.data[c][key].map(function (parking) {
        return _this4._renderParking(parking);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      if (this.data == undefined) return html(_t11 || (_t11 = _`Loading...`));
      var lastUpdate = '';
      if (this.data["Luxembourg"]['Centre']) {
        lastUpdate = this.data["Luxembourg"]['Centre'][0].lastupdate;
        lastUpdate = dayjs(lastUpdate).format('DD/MM/YYYY HH:mm');
      }
      return html(_t12 || (_t12 = _`
            <style>${0}</style>
            <div class="mobility__container mobility__container--${0}">
            ${0}
            ${0}

            <p class="guidage-parking__infos" align="center">${0}: ${0}</p><br />
            
            </div>
        `), css, this.language, !this.showall ? html(_t13 || (_t13 = _`
            <select class="guidage-parking-nav guidage-parking-nav-arrow" style="background: url('${0}') no-repeat 285px;" @change=${0}>
                ${0}
            </select>
            `), IconArrow, function (e) {
        return _this5._changeSector(e);
      }, Object.keys(this.data).map(function (city, count) {
        return Object.keys(_this5.data[city]).map(function (key) {
          return html(_t14 || (_t14 = _`
                            <option value=${0}>${0} ${0} ${0}</option>
                        `), key + ";" + city, city, _this5._getTranslation('sector'), key);
        });
      })) : ``, this.showall ? this._renderAll() : this._renderSector(), this._getTranslation('updated'), lastUpdate);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        language: {
          type: String
        },
        showall: {
          type: Boolean
        },
        sector: {
          type: String
        },
        city: {
          type: String
        }
      };
    }
  }]);
  return RTLGuidageParking;
}(LitElement);
export { RTLGuidageParking as default };
window.customElements.define('rtl-guidage-parking', RTLGuidageParking);